import PropTypes from 'prop-types'

import { getAssetLink } from '../../../../helpers/get-asset-link'

const MemberItem = ({ data, onBanUser, onUnbanUser }) => {
  return (
    <div className={`member-item view`}>
      <div className="member-item-data">
        <div className="avatar-container">
          <img src={getAssetLink({ path: 'chitown-avatar/avatar', file: data.avatar })} />
        </div>
        <div className="user-name">
          {data.firstName} {data.lastName}
        </div>
      </div>
      <div className="action-buttons">
        {data.banned ? (
          <button
            type="submit"
            className={`button button-primary is-block`}
            style={{ backgroundColor: 'grey', borderColor: 'grey' }}
            onClick={onUnbanUser}
          >
            {'Unban / Add'}
          </button>
        ) : (
          <button type="submit" className={`button button-primary is-block`} onClick={onBanUser}>
            {'Ban / Remove'}
          </button>
        )}
      </div>
    </div>
  )
}

MemberItem.propTypes = {
  data: PropTypes.object,
  onBanUser: PropTypes.func,
  onUnbanUser: PropTypes.func,
}

export default MemberItem
